const actionTypeIdentifier = 'E141DD53-E02B-4BDE-A079-0308B0ADE264';

export const getLinkedCircuits = `GET-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const setLinkedCircuitColSearchStr = `SET-COL-SEARCH-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const resizeLinkedCircuits = `RESIZE-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const sortLinkedCircuits = `SORT-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const selectLinkedCircuit = `SELECT-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const setLinkedCircuitsLoading = `SET-LOADING-LINKED-CIRCUITS-${actionTypeIdentifier}`;
export const resetLinkedCircuits = `RESET-LINKED-CIRCUITS-${actionTypeIdentifier}`;